import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import withRouter from "../Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent, { SponsoredAdCard } from "./SidebarContent"

// import logoSm from "../../assets/images/logo-sm.png"
import logoDark from "../../assets/images/logo01.png"
import logoLight from "../../assets/images/logo-light.png"
import logo from "../../assets/images/brands/trivium logo.jpg"
import SidebarProfileContent from "./SidebarProfileContent"
import mainlogo from "../../assets/images/new_web_logo.png"
import logoSm from "../../assets/images/new_web_logo_only.png"
import SettingsSidebarContent from "./SettingsSidebarContent"

const Sidebar = props => {
  const location = useLocation()
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)

  // Helper to read current sidebar state from DOM classes
  const syncSidebarStateFromDOM = () => {
    const body = document.body
    const isCollapsed = body.classList.contains("vertical-collpsed")
    setIsSidebarCollapsed(isCollapsed)
  }

  // Initialize sidebar state from DOM on mount (run once)
  useEffect(() => {
    syncSidebarStateFromDOM()
  }, [])

  // Keep sidebar collapsed across navigation: if the user has collapsed it,
  // don't let route changes auto-expand it. It can only be changed via tToggle.
  useEffect(() => {
    if (!isSidebarCollapsed) return

    const body = document.body
    const windowSize = document.documentElement.clientWidth

    body.classList.add("vertical-collpsed")

    if (windowSize > 991) {
      body.setAttribute("data-sidebar-size", "sm")
    }
  }, [location, isSidebarCollapsed])

  function tToggle() {
    const body = document.body
    const windowSize = document.documentElement.clientWidth

    // Match the original Skote/Vertical header behavior exactly
    body.classList.toggle("vertical-collpsed")
    body.classList.toggle("sidebar-enable")

    if (windowSize > 991) {
      body.getAttribute("data-sidebar-size") === "sm" && windowSize > 991
        ? body.setAttribute("data-sidebar-size", "lg")
        : body.setAttribute("data-sidebar-size", "sm")
    }

    // Sync local React state with DOM for children like SidebarContent
    setTimeout(syncSidebarStateFromDOM, 0)
  }

  // AI CMO used to auto-collapse the moment the page was visited (pathname-based), which looked
  // jarring next to every other page keeping the sidebar as the user left it. Collapse instead
  // only once results actually start showing — AppScanner.jsx dispatches this event once its
  // `scanned` state flips true (loading animation or an instant cache hit alike) — so the search
  // entry screen itself still looks consistent with the rest of the app.
  useEffect(() => {
    const handleResultsLoading = () => {
      if (!document.body.classList.contains("vertical-collpsed")) tToggle()
    }
    window.addEventListener("ai-cmo:results-loading", handleResultsLoading)
    return () => window.removeEventListener("ai-cmo:results-loading", handleResultsLoading)
  }, [])

  // useEffect(() => {
  //   // var verticalOverlay = document.getElementsByClassName("vertical-overlay");
  //   if (document.body.classList.contains("vertical-collpsed") && document.body.classList.contains("sidebar-enable")) {
  //     // verticalOverlay[0].addEventListener("click", function () {
  //       document.body.classList.remove("vertical-collpsed");
  //       document.body.classList.remove("sidebar-enable");

  //     };
  //   // }
  // });

  return (
    <React.Fragment>
      <div className="vertical-menu" style={{ background: "#171821" }}>
        <div style={{ flexShrink: 0 }}>
          <div className="navbar-brand-box d-flex align-items-center" style={{
            borderBottom: "1px solid #2C2D33",
            background: "#171821",
            boxSizing: "border-box",
            padding: "0.5rem 1rem",
            minHeight: "80px",
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            {/* Logo container */}
            <Link to="/" className="logo logo-light" style={{ maxWidth: "180px" }}>
              {/* Full logo for expanded sidebar only.
                  NOTE: Do NOT force display here so theme CSS can hide it when collapsed. */}
              <span className="logo-lg" style={{ alignItems: 'center' }}>
                <div className="d-flex logo_inn">
                  <img
                    src={mainlogo}
                    alt="Logo"
                    height="60"
                    style={{
                      objectFit: 'contain'
                    }}
                  />
                </div>
              </span>
            </Link>

            <button
              onClick={() => {
                tToggle()
              }}
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
              style={{
                background: "transparent",
                border: "none",
                color: "#ffffff",
                borderRadius: "4px",
                flexShrink: 0,
                marginLeft: "auto"
              }}
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>
        </div>

        {location.pathname === "/profile" ||
          location.pathname === "/profile/settings" ||
          location.pathname === "/about-us" ||
          location.pathname === "/faq" ||
          location.pathname === "/support" ||
          location.pathname === "/contact-us" ? (
          <div
            className={`sidebar-menu-scroll ${isSidebarCollapsed ? 'hide-scrollbar' : ''}`}
            style={isSidebarCollapsed ? { scrollbarWidth: 'none', msOverflowStyle: 'none' } : {}}
          >
            {props.type !== "condensed" ? (
              <SettingsSidebarContent isCollapsed={isSidebarCollapsed} />
            ) : (
              <SettingsSidebarContent isCollapsed={isSidebarCollapsed} />
            )}
          </div>
        ) : (
          <React.Fragment>
            <div
              className={`sidebar-menu-scroll ${isSidebarCollapsed ? 'hide-scrollbar' : ''}`}
              style={isSidebarCollapsed ? { scrollbarWidth: 'none', msOverflowStyle: 'none' } : {}}
            >
              {props.type !== "condensed" ? (
                <SidebarContent isCollapsed={isSidebarCollapsed} />
              ) : (
                <SidebarContent isCollapsed={isSidebarCollapsed} />
              )}
            </div>

            {/* A real flex sibling of the header and `.sidebar-menu-scroll` above —
                not nested inside the scrolling region — so it just takes the height
                its content needs and the browser guarantees it can never overlap or
                be overlapped by the scrolling menu. Hidden (not unmounted) when
                collapsed, so the fade is smooth rather than a hard pop. */}
            <div style={{
              borderTop: '1px solid rgba(255, 255, 255, 0.05)',
              paddingTop: '0px',
              paddingBottom: '2px',
              flexShrink: 0,
              backgroundColor: '#171821',
              overflow: 'hidden',
              transition: 'opacity 0.3s ease, max-height 0.3s ease',
              opacity: !isSidebarCollapsed ? 1 : 0,
              maxHeight: !isSidebarCollapsed ? '500px' : '0px',
              pointerEvents: !isSidebarCollapsed ? 'auto' : 'none'
            }}>
              <SponsoredAdCard variant="desktop" />
            </div>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  )
}

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
